import React, { useState, useEffect } from 'react';
import { Dialog, DialogContent, DialogActions, Button } from '@mui/material';
import { Snackbar } from '@mui/material';
import CustomSnackbar from '../../../Optics/Components/CustomSnackbar';
import { GET_ESTIMATE_API_URL } from '../../../Optics/OpticApiConfig';
import axios from 'axios';

const ModalEstimate = ({ open, onClose, projectId }) => {
 const { showSnackbar, snackbarOpen, handleCloseSnackbar, snackbarMessage, snackbarClass } = CustomSnackbar();
 const [estimates, setEstimate] = useState({ Cables: [], PonBoxes: [], Divider: [], Coupling: [], Fob: [], CableWork: [], CableWork2: [], PonBoxWork: [], FobWork: [], Fastening: [] });
 const token = localStorage.getItem('token');

   const LoadingLogs = async (setEstimate, showSnackbar) => {
      try {
        
        const result = await axios.get(`${GET_ESTIMATE_API_URL}`, {
            headers: {
              'Authorization': `Bearer ${token}`
            },
            params: {
              projectId: projectId
            }
          });
        setEstimate(result.data);
      } catch (error) {
        showSnackbar('Ошибка при получении логов', 'snackbarError');
      }
    };
  
  useEffect(() => {
    if (open) {
      LoadingLogs(setEstimate, showSnackbar);
    }
  }, [open]);

  return (
    <Dialog open={open} className="modalStyleEstimate">
      <DialogContent>
        <label style={{ color: '#dfab01', fontSize: '20px', fontFamily: 'unset',textShadow: '2px 2px 4px #242424' }}>Смета</label>
        <hr className='horizontalLineModal'/>
        <div className="tableContainerEstimates">
       
  {estimates?.cables?.length === 0 && estimates?.ponBoxes?.length === 0 && estimates?.divider?.length === 0 && 
  estimates?.coupling?.length === 0 && estimates?.fob?.length === 0 && estimates?.fastening?.length === 0? (
  <p>Нет данных для отображения</p>
) : (
  
  <table>
    <thead>
    <tr>
      <th colSpan="3" style={{
        color: 'black',
        fontSize: '16px',
        fontFamily: 'unset',
        textAlign: 'left',
        padding: '5px'
      }}>
        Материалы
      </th>
    </tr>
    <tr>
      <th>Тип</th>
      <th>Название</th>
      <th>Кол.</th>
      {/* <th>Ч/Ч</th> */}
    </tr>
  </thead>
    <tbody>
      {estimates?.cables?.map((item) => (
        <tr key={`cable-${item.cableId}`}>
          <td>Кабель</td>
          <td>{item.cableName}</td>
          <td>{item.totalLength} м.</td>
          {/* <td>{item.cableChCh}</td> */}
        </tr>
      ))}
       {estimates?.box?.map((item) => (
        <tr key={`box-${item.boxId}`}>
          <td>Ящик</td>
          <td>{item.boxModel}</td>
          <td>{item.boxCount} шт.</td>
          {/* <td>{item.boxChCh}</td> */}
        </tr>
      ))}
       {estimates?.fastening?.filter(item => item.fasteningCount > 0)
        .map(item => (
        <tr key={`fastening-${item.fasteningCount}`}>
          <td>{item.type}</td>
          <td>{item.fasteningDescription}</td>
          <td>{item.fasteningCount} шт.</td>
          {/* <td>{item.weldingChCh}</td> */}
        </tr>
      ))}
        {estimates?.tensioner?.filter(item => item.fasteningCount > 0)
        .map(item => (
        <tr key={`tensioner-${item.fasteningCount}`}>
          <td>{item.type}</td>
          <td>{item.fasteningDescription}</td>
          <td>{item.fasteningCount} шт.</td>
          {/* <td>{item.weldingChCh}</td> */}
        </tr>
      ))}
        {estimates?.seed?.filter(item => item.fasteningCount > 0)
        .map(item => (
        <tr key={`seed-${item.fasteningCount}`}>
          <td>{item.type}</td>
          <td>{item.fasteningDescription}</td>
          <td>{item.fasteningCount} шт.</td>
          {/* <td>{item.weldingChCh}</td> */}
        </tr>
      ))}
        {estimates?.anchorBox?.filter(item => item.anchorCount > 0)
        .map(item => (
        <tr key={`anchorBox-${item.anchorCount}`}>
          <td>{item.type}</td>
          <td>{item.anchorDescription}</td>
          <td>{item.anchorCount} шт.</td>
          {/* <td>{item.weldingChCh}</td> */}
        </tr>
      ))}
      {estimates?.ponBoxes?.map((item) => (
        <tr key={`pon-${item.ponBoxId}`}>
          <td>Пон-бокс</td>
          <td>{item.ponBoxName}</td>
          <td>{item.ponBoxCount} шт.</td>
          {/* <td>{item.ponBoxChCh}</td> */}
        </tr>
      ))}
      {estimates?.divider?.map((item) => (
        <tr key={`divider-${item.dividerId}`}>
          <td>Делитель</td>
          <td>{item.dividerName}</td>
          <td>{item.dividerCount} шт.</td>
          {/* <td>{item.dividerChCh}</td> */}
        </tr>
      ))}
       {estimates?.coupling?.map((item) => (
        <tr key={`coupling-${item.couplingId}`}>
          <td>Муфта</td>
          <td>{item.couplingName}</td>
          <td>{item.couplingCount} шт.</td>
           {/* <td>{item.couplingChCh}</td> */}
        </tr>
      ))}
        {estimates?.fob?.map((item) => (
        <tr key={`fob-${item.fobId}`}>
          <td>Фоб</td>
          <td>{item.fobName}</td>
          <td>{item.fobCount} шт.</td>
          {/* <td>{item.fobChCh}</td> */}
        </tr>
      ))}
        {estimates?.adapter?.map((item) => (
        <tr key={`adapter-${item.polishingAdapterId}`}>
          <td>Адаптер</td>
          <td>{item.polishingAdapterType}</td>
          <td>{item.adapterCount} шт.</td>
          {/* <td>{item.adapterChCh}</td> */}
        </tr>
      ))}
       {estimates?.pigtail?.map((item) => (
        <tr key={`pigtail-${item.polishingPigtailId}`}>
          <td>Пигтейл</td>
          <td>{item.polishingPigtailType}</td>
          <td>{item.pigtailCount} шт.</td>
          {/* <td>{item.pigtailChCh}</td> */}
        </tr>
      ))}
     {estimates?.welding
        ?.filter(item => item.weldingCount > 0)
        .map(item => (
          <tr key={`welding-${item.sleeve}`}>
            <td>{item.sleeve}</td>
            <td>{item.sleeveDescription}</td>
            <td>{item.weldingCount} шт.</td>
            {/* <td>{item.weldingChCh}</td> */}
          </tr>
      ))}
    </tbody>
  </table>
)}



{/* ---------------------------------------------------- */}
 {estimates?.cables?.length === 0 && estimates?.ponBoxes?.length === 0 && estimates?.divider?.length === 0 && 
  estimates?.coupling?.length === 0 && estimates?.fob?.length === 0 && estimates?.cableWork?.length === 0 && estimates?.ponBoxWork?.length === 0 ? (
  <p>Нет данных для отображения</p>
) : (
  <table>
     <thead>
    <tr>
      <th colSpan="8" style={{
        color: 'black',
        fontSize: '16px',
        fontFamily: 'unset',
        textAlign: 'left',
        padding: '5px'
      }}>
        Работы
      </th>
    </tr>
    <tr>
      <th>Наименование работы</th>
      <th>Ед. Изм.</th> 
      <th>Итого(шт.)</th>
      <th>Пробросов</th>
      <th>ч/м</th>
      <th>Стоимость (грн.)</th>
      <th>Итого (грн.)</th>
      <th>Итого (ч/ч)</th>
    </tr>
  </thead>
    
    <tbody>
        
     {estimates?.cableWork?.totalLength > 0 && (
      <tr>
        <td>{estimates.cableWork.workName}</td>
        <td>{estimates.cableWork.measurement}</td>
        <td>{estimates.cableWork.totalLength}</td>
        <td>{estimates.cableWork.forwarding}</td>
        <td>{estimates.cableWork.chCh}</td>
        <td>{estimates.cableWork.price}</td>
        <td>{estimates.cableWork.workPrice}</td>
        <td>{estimates.cableWork.totalChChFormatted}</td>
      </tr>
    )}
       {estimates?.cableWork2?.totalLength > 0 && (
        <tr >
         <td>{estimates.cableWork2.workName}</td>
        <td>{estimates.cableWork2.measurement}</td>
        <td>{estimates.cableWork2.totalLength}</td>
        <td>{estimates.cableWork2.forwarding}</td>
        <td>{estimates.cableWork2.chCh}</td>
        <td>{estimates.cableWork2.price}</td>
        <td>{estimates.cableWork2.workPrice}</td>
        <td>{estimates.cableWork2.totalChChFormatted}</td>
        </tr>
      )}
        {estimates?.ponBoxWork?.totalLength > 0 && (
        <tr >
         <td>{estimates.ponBoxWork.workName}</td>
        <td>{estimates.ponBoxWork.measurement}</td>
        <td>{estimates.ponBoxWork.totalLength}</td>
        <td>{estimates.ponBoxWork.forwarding}</td>
        <td>{estimates.ponBoxWork.chCh}</td>
        <td>{estimates.ponBoxWork.price}</td>
        <td>{estimates.ponBoxWork.workPrice}</td>
        <td>{estimates.ponBoxWork.totalChChFormatted}</td>
        </tr>
      )}

      {estimates?.couplingWork?.totalLength > 0 && (
        <tr >
         <td>{estimates.couplingWork.workName}</td>
        <td>{estimates.couplingWork.measurement}</td>
        <td>{estimates.couplingWork.totalLength}</td>
        <td>{estimates.couplingWork.forwarding}</td>
        <td>{estimates.couplingWork.chCh}</td>
        <td>{estimates.couplingWork.price}</td>
        <td>{estimates.couplingWork.workPrice}</td>
        <td>{estimates.couplingWork.totalChChFormatted}</td>
        </tr>
      )}
      {estimates?.fobWork?.totalLength > 0 && (
        <tr >
         <td>{estimates.fobWork.workName}</td>
        <td>{estimates.fobWork.measurement}</td>
        <td>{estimates.fobWork.totalLength}</td>
        <td>{estimates.fobWork.forwarding}</td>
        <td>{estimates.fobWork.chCh}</td>
        <td>{estimates.fobWork.price}</td>
        <td>{estimates.fobWork.workPrice}</td>
        <td>{estimates.fobWork.totalChChFormatted}</td>
        </tr>
      )}
       {estimates?.dividerWork?.totalLength > 0 && (
        <tr >
         <td>{estimates.dividerWork.workName}</td>
        <td>{estimates.dividerWork.measurement}</td>
        <td>{estimates.dividerWork.totalLength}</td>
        <td>{estimates.dividerWork.forwarding}</td>
        <td>{estimates.dividerWork.chCh}</td>
        <td>{estimates.dividerWork.price}</td>
        <td>{estimates.dividerWork.workPrice}</td>
        <td>{estimates.dividerWork.totalChChFormatted}</td>
        </tr>
      )}

      {estimates?.weldingWork?.totalLength > 0 && (
        <tr >
         <td>{estimates.weldingWork.workName}</td>
        <td>{estimates.weldingWork.measurement}</td>
        <td>{estimates.weldingWork.totalLength}</td>
        <td>{estimates.weldingWork.forwarding}</td>
        <td>{estimates.weldingWork.chCh}</td>
        <td>{estimates.weldingWork.price}</td>
        <td>{estimates.weldingWork.workPrice}</td>
        <td>{estimates.weldingWork.totalChChFormatted}</td>
        </tr>
      )}

     {estimates?.boxWork?.length > 0 && (
        <tr >
         <td>{estimates.boxWork.workName}</td>
        <td>{estimates.boxWork.measurement}</td>
        <td>{estimates.boxWork.totalLength}</td>
        <td>{estimates.boxWork.forwarding}</td>
        <td>{estimates.boxWork.chCh}</td>
        <td>{estimates.boxWork.price}</td>
        <td>{estimates.boxWork.workPrice}</td>
        <td>{estimates.boxWork.totalChChFormatted}</td>
        </tr>
      )}
      {/* {estimates?.ponBoxes?.map((item) => (
        <tr key={`pon-${item.ponBoxId}`}>
          <td>Пон-бокс</td>
          <td>{item.ponBoxName}</td>
          <td>{item.ponBoxCount} шт.</td>
          <td>{item.ponBoxChCh}</td>
        </tr>
      ))}
      {estimates?.divider?.map((item) => (
        <tr key={`divider-${item.dividerId}`}>
          <td>Делитель</td>
          <td>{item.dividerName}</td>
          <td>{item.dividerCount} шт.</td>
          <td>{item.dividerChCh}</td>
        </tr>
      ))}
       {estimates?.coupling?.map((item) => (
        <tr key={`coupling-${item.couplingId}`}>
          <td>Муфта</td>
          <td>{item.couplingName}</td>
          <td>{item.couplingCount} шт.</td>
           <td>{item.couplingChCh}</td>
        </tr>
      ))}
        {estimates?.fob?.map((item) => (
        <tr key={`fob-${item.fobId}`}>
          <td>Фоб</td>
          <td>{item.fobName}</td>
          <td>{item.fobCount} шт.</td>
          <td>{item.fobChCh}</td>
        </tr>
      ))}
        {estimates?.adapter?.map((item) => (
        <tr key={`adapter-${item.polishingAdapterId}`}>
          <td>Адаптер</td>
          <td>{item.polishingAdapterType}</td>
          <td>{item.adapterCount} шт.</td>
          <td>{item.adapterChCh}</td>
        </tr>
      ))}
       {estimates?.pigtail?.map((item) => (
        <tr key={`pigtail-${item.polishingPigtailId}`}>
          <td>Пигтейл</td>
          <td>{item.polishingPigtailType}</td>
          <td>{item.pigtailCount} шт.</td>
          <td>{item.pigtailChCh}</td>
        </tr>
      ))}
     {estimates?.welding
        ?.filter(item => item.weldingCount > 0)
        .map(item => (
          <tr key={`welding-${item.sleeve}`}>
            <td>{item.sleeve}</td>
            <td>{item.sleeveDescription}</td>
            <td>{item.weldingCount} шт.</td>
            <td>{item.weldingChCh}</td>
          </tr>
      ))} */}
    </tbody>
  </table>
)}
        </div>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} class='buttonIsHideModal'>
          Закрыть
        </Button>
      </DialogActions>

      {/* Snackbar */}
      <Snackbar
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        message={snackbarMessage}
        ContentProps={{
          style: {
            color: snackbarClass === 'snackbarOk' ? '#ffda62' : '#202020'
          }
        }}
      />
    </Dialog>
  );
};

export default ModalEstimate;
